import { createContext } from 'react';

import QuickReplyTemplatesStore from './QuickReplyTemplatesStore';

const QuickReplyTemplatesStoreContext = createContext<{
  store: QuickReplyTemplatesStore | null;
}>({
  store: null
});

const QuickReplyTemplatesStoreProvider =
  QuickReplyTemplatesStoreContext.Provider;

export { QuickReplyTemplatesStoreContext, QuickReplyTemplatesStoreProvider };
